(() => {
  const TRIGGER_SELECTOR =
    '[data-floating-filter-trigger]';

  const DESKTOP_FILTERS_SELECTOR =
    '#FacetsWrapperDesktop';

  const MOBILE_TRIGGER_SELECTOR =
    '.mobile-facets__wrapper .mobile-facets__open-wrapper';

  const MOBILE_DRAWER_SELECTOR =
    '.mobile-facets__wrapper details.mobile-facets__disclosure';

  const MOBILE_CLOSE_SELECTOR =
    '.mobile-facets__wrapper .mobile-facets__close';

  const MOBILE_BREAKPOINT = 749;
  const SHOW_AFTER_SCROLL = 320;
  const HIDE_BEFORE_PAGE_END = 400;

  /*
   * Aumenta questo valore per far salire
   * maggiormente la pagina su desktop.
   */
  const DESKTOP_EXTRA_OFFSET = 180;

  let savedMobileScrollPosition = null;

  function isIPadDevice() {
  return (
    /iPad/i.test(navigator.userAgent) ||
    (
      navigator.platform === 'MacIntel' &&
      navigator.maxTouchPoints > 1
    )
  );
}


/*
 * Modalità filtri tablet:
 *
 * - viewport 750–1199px
 *   oppure
 *
 * - vero iPad, anche in landscape
 *   oltre 1199px.
 */
function isTabletFilterMode() {
  return (
    (
      window.innerWidth >= 750 &&
      window.innerWidth <= 1199
    ) ||
    isIPadDevice()
  );
}


/*
 * La classe em-ipad viene usata dal CSS
 * per mostrare l'interfaccia mobile filtri.
 */
function syncTabletFilterMode() {
  document.documentElement.classList.toggle(
    'em-ipad',
    isTabletFilterMode()
  );
}


syncTabletFilterMode();


function isMobileViewport() {
  return (
    window.innerWidth <= MOBILE_BREAKPOINT ||
    isTabletFilterMode()
  );
}



  function collapseMobileFloatingButton() {
  document
    .querySelectorAll(TRIGGER_SELECTOR)
    .forEach((button) => {
      button.classList.remove(
        'is-mobile-expanded'
      );
    });
}

  function getCurrentScrollPosition() {
    return (
      window.scrollY ||
      document.documentElement.scrollTop ||
      0
    );
  }

  function getHeaderOffset() {
    const header =
      document.querySelector('.header-wrapper') ||
      document.querySelector('#shopify-section-header') ||
      document.querySelector('header');

    return header
      ? header.getBoundingClientRect().height + 20
      : 20;
  }

 function updateButtonVisibility() {
  const currentScroll =
    window.scrollY ||
    document.documentElement.scrollTop ||
    0;

  const documentHeight = Math.max(
    document.body.scrollHeight,
    document.documentElement.scrollHeight,
    document.body.offsetHeight,
    document.documentElement.offsetHeight,
    document.body.clientHeight,
    document.documentElement.clientHeight
  );

  const remainingDistance =
    documentHeight -
    (currentScroll + window.innerHeight);

  const hasScrolledEnough =
    currentScroll >= SHOW_AFTER_SCROLL;

  const isNearPageEnd =
    remainingDistance <= HIDE_BEFORE_PAGE_END;

  const shouldShow =
    hasScrolledEnough &&
    !isNearPageEnd;

  document
    .querySelectorAll(TRIGGER_SELECTOR)
    .forEach((button) => {
      button.classList.toggle(
        'is-visible',
        shouldShow
      );

      button.setAttribute(
        'aria-hidden',
        shouldShow ? 'false' : 'true'
      );

      button.tabIndex = shouldShow ? 0 : -1;
    });
}

  /**
   * Ripristina la posizione della pagina più volte.
   * Serve perché il tema può spostare lo scroll
   * durante l'animazione di apertura o chiusura.
   */
  function restoreMobileScroll(position) {
    if (
      typeof position !== 'number' ||
      Number.isNaN(position)
    ) {
      return;
    }

    const htmlElement = document.documentElement;
    const previousScrollBehavior =
      htmlElement.style.scrollBehavior;

    htmlElement.style.scrollBehavior = 'auto';

    const restore = () => {
      window.scrollTo({
        top: position,
        left: 0,
        behavior: 'auto'
      });
    };

    restore();

    requestAnimationFrame(() => {
      restore();

      requestAnimationFrame(() => {
        restore();
      });
    });

    window.setTimeout(restore, 60);
    window.setTimeout(restore, 150);
    window.setTimeout(restore, 300);

    window.setTimeout(() => {
      htmlElement.style.scrollBehavior =
        previousScrollBehavior;
    }, 350);
  }

  /**
   * Mobile:
   * apre il pannello senza spostare la pagina.
   */
  function openMobileFilters() {
    const mobileTrigger = document.querySelector(
      MOBILE_TRIGGER_SELECTOR
    );

    if (!mobileTrigger) {
      return;
    }

    const drawerDetails =
      mobileTrigger.closest('details');

    if (drawerDetails?.open) {
      return;
    }

    savedMobileScrollPosition =
      getCurrentScrollPosition();

    mobileTrigger.click();

    restoreMobileScroll(
      savedMobileScrollPosition
    );
  }

  /**
   * Desktop:
   * scorre più in alto per mostrare
   * completamente la barra dei filtri.
   */
  function scrollToDesktopFilters() {
    const filters = document.querySelector(
      DESKTOP_FILTERS_SELECTOR
    );

    if (!filters) {
      return;
    }

    const targetPosition =
      filters.getBoundingClientRect().top +
      window.scrollY -
      getHeaderOffset() -
      DESKTOP_EXTRA_OFFSET;

    window.scrollTo({
      top: Math.max(targetPosition, 0),
      behavior: 'smooth'
    });

    filters.classList.remove(
      'floating-filter-target-highlight'
    );

    requestAnimationFrame(() => {
      filters.classList.add(
        'floating-filter-target-highlight'
      );
    });

    window.setTimeout(() => {
      filters.classList.remove(
        'floating-filter-target-highlight'
      );
    }, 900);
  }

  function handleFloatingFilterClick(event) {
  const target = event.target;

  if (!(target instanceof Element)) {
    return;
  }

  const button = target.closest(
    TRIGGER_SELECTOR
  );

  if (!button) {
    return;
  }

  event.preventDefault();
  event.stopPropagation();

  /*
   * MOBILE:
   * primo tocco = mostra il testo;
   * secondo tocco = apre il drawer.
   */
  if (isMobileViewport()) {
    const isExpanded =
      button.classList.contains(
        'is-mobile-expanded'
      );

    if (!isExpanded) {
      collapseMobileFloatingButton();

      button.classList.add(
        'is-mobile-expanded'
      );

      return;
    }

    button.classList.remove(
      'is-mobile-expanded'
    );

    openMobileFilters();
    return;
  }

  /*
   * DESKTOP:
   * comportamento originale invariato.
   */
  scrollToDesktopFilters();
}
  /**
   * Quando viene cliccata la X del pannello mobile,
   * lascia chiudere normalmente il drawer e poi
   * riporta la pagina alla posizione precedente.
   */
  function handleMobileCloseClick(event) {
    if (!isMobileViewport()) {
      return;
    }

    const target = event.target;

    if (!(target instanceof Element)) {
      return;
    }

    const closeButton = target.closest(
      MOBILE_CLOSE_SELECTOR
    );

    if (!closeButton) {
      return;
    }

    const positionToRestore =
      savedMobileScrollPosition;

    /*
     * Non usare preventDefault:
     * il tema deve poter chiudere il drawer.
     */
    window.setTimeout(() => {
      restoreMobileScroll(positionToRestore);
    }, 0);

    window.setTimeout(() => {
      restoreMobileScroll(positionToRestore);
    }, 180);
  }

  /**
   * Controllo aggiuntivo sulla chiusura del drawer.
   * Copre anche chiusure eseguite dal tema.
   */
  function handleMobileDrawerToggle(event) {
    const drawer = event.target;

    if (
      !(drawer instanceof HTMLDetailsElement) ||
      !drawer.matches(MOBILE_DRAWER_SELECTOR)
    ) {
      return;
    }

    if (drawer.open) {
      if (savedMobileScrollPosition === null) {
        savedMobileScrollPosition =
          getCurrentScrollPosition();
      }

      restoreMobileScroll(
        savedMobileScrollPosition
      );

      return;
    }

    const positionToRestore =
      savedMobileScrollPosition;

    restoreMobileScroll(positionToRestore);

    window.setTimeout(() => {
      restoreMobileScroll(positionToRestore);
      savedMobileScrollPosition = null;
    }, 350);
  }

  /**
 * Quando viene applicato o modificato un filtro mobile,
 * non deve più essere ripristinata la vecchia posizione.
 */
function handleMobileFilterChange(event) {
  if (!isMobileViewport()) {
    return;
  }

  const target = event.target;

  if (!(target instanceof Element)) {
    return;
  }

  const mobileForm = target.closest(
    '#FacetFiltersFormMobile'
  );

  if (!mobileForm) {
    return;
  }

  savedMobileScrollPosition = null;
}

  document.addEventListener(
    'click',
    handleFloatingFilterClick,
    true
  );

  document.addEventListener(
    'click',
    handleMobileCloseClick,
    true
  );

  document.addEventListener(
    'toggle',
    handleMobileDrawerToggle,
    true
  );

  document.addEventListener(
  'change',
  handleMobileFilterChange,
  true
);

 function handlePageScroll() {
  updateButtonVisibility();

  if (isMobileViewport()) {
    collapseMobileFloatingButton();
  }
}

window.addEventListener(
  'scroll',
  handlePageScroll,
  { passive: true }
);

  function handleWindowResize() {
  syncTabletFilterMode();
  collapseMobileFloatingButton();
  updateButtonVisibility();
}

window.addEventListener(
  'resize',
  handleWindowResize
);

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      updateButtonVisibility
    );
  } else {
    updateButtonVisibility();
  }

  document.addEventListener(
    'shopify:section:load',
    updateButtonVisibility
  );
})();

/* ==========================================================
   E. MARINELLA
   IPAD MOBILE FILTER DRAWER ADAPTER
   ========================================================== */

(() => {

  function isIPadMode() {
    return document.documentElement.classList.contains(
      'em-ipad'
    );
  }


  function openDrawer(details, summary) {

    details.setAttribute(
      'open',
      ''
    );

    summary.setAttribute(
      'aria-expanded',
      'true'
    );

    document.body.classList.add(
      'overflow-hidden-mobile'
    );

    requestAnimationFrame(() => {

      requestAnimationFrame(() => {

        details.classList.add(
          'menu-opening'
        );

      });

    });

  }


  function closeDrawer(details, summary) {

    details.classList.remove(
      'menu-opening'
    );

    summary.setAttribute(
      'aria-expanded',
      'false'
    );

    document.body.classList.remove(
      'overflow-hidden-mobile'
    );

    setTimeout(() => {

      details.removeAttribute(
        'open'
      );

    }, 300);

  }


  document.addEventListener(
    'click',
    (event) => {

      if (!isIPadMode()) {
        return;
      }


      /*
       * Gestisce SOLO il vero
       * "Filter and sort".
       *
       * NON intercetta il floating button.
       */
      const summary =
        event.target.closest(
          '.products-toolbar .mobile-facets__open-wrapper'
        );


      if (!summary) {
        return;
      }


      const details =
        summary.closest(
          'details.mobile-facets__disclosure'
        );


      if (!details) {
        return;
      }


      event.preventDefault();
      event.stopImmediatePropagation();


      const isOpen =
        details.hasAttribute('open') &&
        details.classList.contains(
          'menu-opening'
        );


      if (isOpen) {

        closeDrawer(
          details,
          summary
        );

      } else {

        openDrawer(
          details,
          summary
        );

      }

    },
    true
  );

})();